export default __webpack_public_path__ + "static/media/refill.6c50cac4.svg";